// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"37de57c1","219":"296b4a7c","455":"399606b7","555":"e1f326e7","797":"16a6b632","843":"f92e1406","852":"efabf713","924":"5a6a51ac","936":"c7a99729","977":"8c72bf08"}[chunkId] + ".chunk.js";
};